import {
  FaBookOpen,
  FaChartArea,
  FaChartPie,
  FaChartBar,
  FaCog,
  FaDesktop,
  FaPaperPlane,
  FaStream,
} from "react-icons/fa";

export const PATH_HOME = "/";

const menu = [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <FaChartArea />,
    href: PATH_HOME,
  },
  {
    id: "enviar-mensagem",
    title: "Envio único",
    icon: <FaPaperPlane />,
    href: "/envio-unico",
  },
  {
    id: "workspaces",
    title: "Workspaces",
    icon: <FaDesktop />,
    href: "/workspaces",
    submenu: [
      {
        id: "novo-workspace",
        title: "Novo Workspace",
        href: "/workspaces/novo",
        isPathParam: false,
      },
      {
        id: "detalhe-workspace",
        title: "Detalhe do Workspace",
        href: "/workspaces/detalhes/:id",
        isPathParam: true,
      },
    ],
  },
  {
    id: "relatorios",
    title: "Relatórios",
    icon: <FaChartBar />,
    href: "/relatorios",
  },
  {
    id: "log-mensagens",
    title: "Log de Mensagens",
    icon: <FaStream />,
    href: "/log-de-mensagens",
    submenu: [
      {
        id: "detalhe-log-mensagens",
        title: "Detalhe do Log de Mensagem",
        href: "/log-de-mensagens/:id",
        isPathParam: true,
      },
    ],
  },
  {
    id: "configuracoes",
    title: "Configurações",
    icon: <FaCog />,
    href: "/configuracoes/meu-cadastro",
    submenu: [
      {
        id: "meu-cadastro",
        title: "Meu Cadastro",
        href: "/configuracoes/meu-cadastro",
        isPathParam: true,
      },
      {
        id: "colaboradores",
        title: "Colaboradores",
        href: "/configuracoes/colaboradores",
        isPathParam: true,
      },
    ],
  },
  {
    id: "documentacao",
    title: "Documentação",
    icon: <FaBookOpen />,
    href: "/documentacao",
  },
];

export const hiddenForEmployee = [
  "configuracoes",
]
export default menu;
